export const cardStyle = {
  width: 220,
  minHeight: 200,
  verticalAlign: 'top',
  borderLeft: '7px solid rgb(51, 51, 51)',
  boxShadow: '1px 1px 5px 1px rgba(51, 51, 51, 0.51)',
  borderRadius: '0.1rem',
  backgroundColor: '#fff',
  position: 'relative'
};

export const titleBox = {
  fontFamily: 'Roboto, sans-serif',
  backgroundColor: 'rgb(255,255,255)',
  borderRadius: '2px',
  boxShadow: 'rgba(0, 0, 0, 0.12) 0px 1px 6px, rgba(0, 0, 0, 0.12) 0px 1px 4px',
  boxSizing: 'border-box',
  transition: 'all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms',
};

export const cardBox = {
  display: 'inline-block',
  margin: '20px 30px 20px 0',
  cursor: 'pointer'
};

export const title = {
  padding: '16px',
  fontWeight: '400',
  fontStretch: '100%',
  margin: '0',
  fontSize: '24px',
  color: 'rgba(0, 0, 0, 0.87)',
  lineHeight: '36px'
};

export const reportIconDiv = {
  borderRadius: '50%',
  backgroundColor: 'rgb(109, 199, 195)',
  width: '60px',
  height: '60px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  position: 'absolute',
  top: '10px',
  right: '10px'
};

export const reportTitleBox = {
  position: 'absolute',
  bottom: '0',
  margin: 'auto',
  padding: '10px'
};

export const headingStyle = {
  fontSize: '22px',
  fontWeight: '600',
  margin: '10px'
};


// WEBPACK FOOTER //
// ./src/containers/CRM/DataReports/style.js